import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useAuth from "../../hooks/useAuth";
import useRefreshToken from "../../hooks/useRefreshToken";
import { useEffect, useState } from "react";

const ProtectedRoute = ({ children }) => {
  const { auth } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(
    auth?.isAuthenticated || false,
  );
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();

  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);

      // If already authenticated, no need to refresh
      if (auth?.isAuthenticated) {
        setIsAuthenticated(true);
        setIsLoading(false);
        return;
      }

      try {
        const refreshed = await refresh();
        setIsAuthenticated(refreshed);
      } catch (err) {
        console.error("Auth refresh failed:", err);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [auth?.isAuthenticated, refresh]);

  // Show loading state while checking authentication
  if (isLoading) {
    return <div>Loading...</div>; // Or your loading component
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
